/**
 * PaymentsSummary — четыре метрики за период (десктоп): успешно, неудачно,
 * возвраты и тёмная карточка «Чистыми». Числа — из сводки bundle.
 */

import {PiggyBank} from 'lucide-react';

import type {PaymentsSummary as Summary} from '@services/payments';
import {formatNumber} from '@utils/format';

import {fmtSignedSom} from '../../Payments.utils';

type PaymentsSummaryProps = {summary: Summary};

export const PaymentsSummary = ({summary}: PaymentsSummaryProps) => (
  <div className="grid grid-cols-4 gap-4">
    <Metric
      dot="#1B7A54"
      label="Успешно проведено"
      value={formatNumber(summary.successSum)}
      sub={`${summary.successCount} платежей · сом`}
    />
    <Metric
      dot="#C6362C"
      label="Неудачных попыток"
      value={String(summary.failedCount)}
      sub={`на ${formatNumber(summary.failedSum)} сом`}
    />
    <Metric
      dot="#B07908"
      label="Возвраты"
      value={fmtSignedSom(summary.refundSum)}
      sub={`${summary.refundCount} возврата · сом`}
    />
    <div className="rounded-[14px] border border-skr-dark bg-skr-dark px-[18px] py-4 text-white">
      <div className="flex items-center gap-[7px] text-[12.5px] text-[#A9B0BE]">
        <PiggyBank className="size-3.5 text-skr-toast-dot" strokeWidth={2} />
        Чистыми за период
      </div>
      <div className="mt-[9px] whitespace-nowrap font-mono text-[26px] font-semibold -tracking-[.02em]">
        {formatNumber(summary.net)}
      </div>
      <div className="mt-[3px] text-xs text-[#8B93A3]">успешно − возвраты · сом</div>
    </div>
  </div>
);

const Metric = ({
  dot,
  label,
  value,
  sub,
}: {
  dot: string;
  label: string;
  value: string;
  sub: string;
}) => (
  <div className="rounded-[14px] border border-skr-line bg-card px-[18px] py-4">
    <div className="flex items-center gap-[7px] text-[12.5px] text-muted-foreground">
      <span className="size-2 rounded-full" style={{background: dot}} />
      {label}
    </div>
    <div className="mt-[9px] whitespace-nowrap font-mono text-[26px] font-semibold -tracking-[.02em]">
      {value}
    </div>
    <div className="mt-[3px] text-xs text-skr-label">{sub}</div>
  </div>
);
